export class PoInvoiceDiscrepancyReportItem{
  poNo: string;
  poAmount: string;
  totalPoInvoiceValue: string;
  projectNo: string;
  projectDescription: string;
  installationProgress: string;
  totalProjectInvoiceValue: string;
  invoiceNo: string;
  invoiceDate: string;
  incomeMonth: string;
  invoiceValue: string;
}